import { parse, stringify } from "query-string";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { useLangNavigate } from "../../../../../hooks/useLangNavigate";

const sort_list = [
  { id: 0, label: "Best_Seller", value: { field: "RATING", direction: "ASC" } },
  {
    id: 1,
    label: "Highest_Price",
    value: { field: "PRICE", direction: "DESC" },
  },
  { id: 2, label: "Lowest_Price", value: { field: "PRICE", direction: "ASC" } },
];

const useSort = () => {
  const navigate = useLangNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const sort = searchParams.get("sort") || null;

  const [sort_modal, set_sort_modal] = useState(false);
  const [active_sort, set_active_sort] = useState(sort_list[0].value);

  // useEffect(() => {
  // if (!parsed_query.sort) {
  // const new_queries = { ...parsed_query };
  // new_queries.sort = `${active_sort?.field}-${active_sort?.direction}`;
  // Object.keys(new_queries).forEach((query_key) => {
  //   if (query_key !== 'sort' && query_key !== 'level') {
  //     new_queries[query_key] = new_queries[query_key].split(',');
  //   }
  // });
  // const new_url = `${location.pathname}?${stringify(new_queries, {
  //   arrayFormat: 'comma'
  // })}`;
  // navigate(new_url);
  // }
  // eslint-disable-next-line
  // }, [active_sort]);

  const activeSortLabel = useMemo(() => {
    if (!sort) return "";
    return sort_list.find(
      (item) =>
        item.value.field === sort.split("-")[0] &&
        item.value.direction === sort.split("-")[1]
    )?.label;
  }, [searchParams.toString()]);

  return [sort_modal, set_sort_modal, sort_list, activeSortLabel];
};

export default useSort;
